import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Target, Zap, Trophy, User, Settings, LogOut } from 'lucide-react';
import { Logo } from './Logo';
import { useAuth } from '../contexts/AuthContext';
import { useUser } from '../contexts/UserContext';
export function Sidebar() {
  const location = useLocation();
  const {
    logout,
    user
  } = useAuth();
  const {
    stats
  } = useUser();
  const navItems = [{
    path: '/',
    icon: Home,
    label: 'Home'
  }, {
    path: '/goals',
    icon: Target,
    label: 'Quests'
  }, {
    path: '/focus',
    icon: Zap,
    label: 'Focus'
  }, {
    path: '/leaderboard',
    icon: Trophy,
    label: 'Leaderboard'
  }, {
    path: '/profile',
    icon: User,
    label: 'Profile'
  }];
  const handleLogout = async () => {
    await logout();
  };
  return <aside className="hidden lg:flex lg:flex-col lg:fixed lg:inset-y-0 lg:w-72 bg-white dark:bg-[#252936] border-r border-gray-200 dark:border-gray-800" data-id="element-490">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200 dark:border-gray-800" data-id="element-491">
        <Logo data-id="element-492" />
      </div>

      {/* User Info */}
      <div className="p-6 border-b border-gray-200 dark:border-gray-800" data-id="element-493">
        <div className="flex items-center gap-3 mb-4" data-id="element-494">
          <img src={user?.photoURL || `https://api.dicebear.com/7.x/avataaars/svg?seed=${user?.uid}`} alt={user?.displayName || 'User'} className="w-12 h-12 rounded-full border-2 border-game-purple" data-id="element-495" />
          <div className="flex-1 min-w-0" data-id="element-496">
            <p className="font-fredoka font-bold text-game-dark dark:text-white truncate" data-id="element-497">
              {user?.displayName || 'QuestZen User'}
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-400 font-quicksand" data-id="element-498">
              Level {stats.level}
            </p>
          </div>
        </div>

        {/* XP Progress */}
        <div className="space-y-2" data-id="element-499">
          <div className="flex justify-between text-xs font-quicksand text-gray-600 dark:text-gray-400" data-id="element-500">
            <span data-id="element-501">{stats.xp % 1000} XP</span>
            <span data-id="element-502">1000 XP</span>
          </div>
          <div className="h-2 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-503">
            <div className="h-full bg-gradient-to-r from-game-purple to-game-teal transition-all duration-500" style={{
            width: `${stats.xp % 1000 / 1000 * 100}%`
          }} data-id="element-504" />
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto" data-id="element-505">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return <Link key={item.path} to={item.path} className={`
                flex items-center gap-3 px-4 py-3 rounded-xl font-fredoka font-medium transition-all
                ${isActive ? 'bg-game-bg-purple text-game-purple' : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800'}
              `} data-id="element-506">
              <Icon className="w-5 h-5" data-id="element-507" />
              <span data-id="element-508">{item.label}</span>
            </Link>;
      })}
      </nav>

      {/* Bottom Actions */}
      <div className="p-4 border-t border-gray-200 dark:border-gray-800 space-y-1" data-id="element-509">
        <Link to="/settings" className="flex items-center gap-3 px-4 py-3 rounded-xl font-fredoka font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all" data-id="element-510">
          <Settings className="w-5 h-5" data-id="element-511" />
          <span data-id="element-512">Settings</span>
        </Link>
        <button onClick={handleLogout} className="w-full flex items-center gap-3 px-4 py-3 rounded-xl font-fredoka font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all" data-id="element-513">
          <LogOut className="w-5 h-5" data-id="element-514" />
          <span data-id="element-515">Log Out</span>
        </button>
      </div>
    </aside>;
}